// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items-list .item[data-v-0af6e62c]{display:block}.items-list a[data-v-0af6e62c]{display:inline-block}", ""]);
// Exports
module.exports = exports;
